import { render, staticRenderFns } from "./ScreensTree.vue?vue&type=template&id=8091d7c8&scoped=true&"
import script from "./ScreensTree.vue?vue&type=script&lang=js&"
export * from "./ScreensTree.vue?vue&type=script&lang=js&"
import style0 from "./ScreensTree.vue?vue&type=style&index=0&id=8091d7c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8091d7c8",
  null
  
)

export default component.exports